export default "<h1>404</h1>\r\n<h2>Page not found!</h2>\r\n<p>Sorry, but the page you were trying to view does not exist. Report this error?</p>\r\n";